import Nav from './components/Nav'
import HomeSection from './sections/HomeSection'
import WorkSection from './sections/WorkSection'
import ProjectSection from './sections/ProjectSection'
import ContactSection from './sections/ContactSection'
import { loadProjects } from './content/loadProjects'

export default function App() {
  const projects = loadProjects()

  return (
    <div className="app" data-testid="app">
      <Nav />
      <main>
        <HomeSection />
        <WorkSection />
        {projects.map((project) => (
          <ProjectSection key={project.slug} project={project} />
        ))}
        <ContactSection />
      </main>
    </div>
  )
}
